import { RECON_MISMATCHES_BLOTTER_PREFIX } from '@src/containers/Blotters/Reconciliation/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

export function migrateReconMismatchesTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyReconTabs = config.tabs?.[RECON_MISMATCHES_BLOTTER_PREFIX];
  if (legacyReconTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyReconTabs,
    blotterType: 'reconMismatches',
  });
}
